import axios from "axios"

export default function verifyEmployee({ id, token }) {
    return new Promise((resolve, reject) => {
        axios.post(`/account/public/api/v1/user/verification/${id}`, { token })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}